/* exported ProductUtils */

const ProductUtils = (() => {
    function getSapCategories(tags) {
        const sapCategories = {};
        const sapCategoryTag = tags.find((tag) => tag.startsWith('NOP:'));

        if (sapCategoryTag) {
            sapCategoryTag.split('-').forEach((item) => {
                const [prefix, value] = item.split(':');
                switch (prefix) {
                    case 'NOP':
                        sapCategories.sapCatP = value;
                        break;
                    case 'NON':
                        sapCategories.sapCatN = value;
                        break;
                    case 'NOK':
                        sapCategories.sapCatK = value;
                        break;
                }
            });
        }

        return sapCategories;
    }

    return { getSapCategories };
})();
